<template>
  <v-card
    v-if="currentUser.id"
    id="user-menu"
    flat
  >
    <v-list three-line>
      <v-menu
        offset-x
        :open-on-hover="mini"
        :close-delay="100"
      >
        <template v-slot:activator="{ on }">
          <v-list-item v-on="on">
            <pa-user-avatar
              class="align-self-center"
              :image="currentUser.profile.photoURL"
              :name="currentUser.profile.displayName"
            />

            <v-list-item-content>
              <v-list-item-title>
                {{ currentUser.profile.displayName || currentUser.email }}
              </v-list-item-title>

              <v-list-item-subtitle class="text-no-wrap text-truncate">
                {{ currentUser.profile.jobTitle }}
              </v-list-item-subtitle>

              <v-list-item-subtitle class="text-no-wrap text-truncate">
                <em>
                  {{ currentOrganization ? currentOrganization.name : $tc('organization._', 0) }}
                </em>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list>
          <v-subheader
            v-if="allOrganizations.length"
            class="text-uppercase"
          >
            {{ allOrganizations.length ? $tc('organization._', 2) : $tc('organization._', 0) }}
          </v-subheader>

          <v-list-item
            v-for="org in allOrganizations.models"
            :key="`organization-${org.id}`"
            :disabled="org.id === $currentOrganization.id"
            @click="changeOrganization(org.id)"
          >
            <v-list-item-action>
              <v-icon
                v-if="org.id === $currentOrganization.id"
                color="primary"
              >
                check
              </v-icon>
            </v-list-item-action>
            <v-list-item-title>
              {{ org.name }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item v-if="isAdmin">
            <v-text-field
              v-model="otherOrg"
              label="Org ID"
              append-icon="send"
              @click.stop
              @click:append="changeOrganization(otherOrg)"
            />
          </v-list-item>

          <v-divider />

          <v-list-item :to="{ name: 'user-profile' }">
            <v-list-item-action>
              <v-icon>account_circle</v-icon>
            </v-list-item-action>
            <v-list-item-title v-t="'auth.profile'" />
          </v-list-item>

          <v-list-item :to="{ name: 'user-preferences' }">
            <v-list-item-action>
              <v-icon>settings</v-icon>
            </v-list-item-action>
            <v-list-item-title v-t="'auth.preferences'" />
          </v-list-item>

          <v-divider />

          <v-list-item @click="signOut()">
            <v-list-item-action>
              <v-icon class="red--text">
                power_settings_new
              </v-icon>
            </v-list-item-action>
            <v-list-item-title v-t="'auth.signout'" />
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list>

    <v-dialog
      v-model="dialogChangeOrg"
      persistent
      :max-width="290"
    >
      <v-card class="text-center pa-2">
        <v-progress-circular
          color="primary"
          indeterminate
        />
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'

import Organizations from '@/models/Organizations'
import { logout } from '@/plugins/stitch'

export default {
  props: {
    mini: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      allOrganizations: new Organizations(),
      dialogChangeOrg: false,
      otherOrg: null
    }
  },
  computed: {
    ...mapState('user', [ 'currentUser', 'isAdmin' ]),
    ...mapState('organizations', [ 'currentOrganization' ])
  },
  mounted () {
    this.allOrganizations.fetch({
      users: this.$currentUser.id
    })
  },
  methods: {
    async changeOrganization (orgId) {
      if (orgId === this.$currentOrganization.id) { return }

      this.dialogChangeOrg = true

      this.$currentUser.currentOrganization = orgId
      await this.$currentUser.save()

      this.$router.push('/')
      this.$store.dispatch('doFirstLoad', { reload: true })
        .then(() => { this.dialogChangeOrg = false })
        .catch(() => { this.dialogChangeOrg = false })
    },
    signOut () {
      logout()
        .then(() => {
          this.$router.go('/login')
        })
        .catch((error) => {
          throw error
        })
    }
  }
}
</script>
